import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
    selector: 'get-started',
    templateUrl: './get-started.component.html',
    styleUrls: ['./get-started.component.scss'],
    standalone: false
})
export class GetStartedComponent implements OnInit {


  form = this.fb.group({
    email: [null, [Validators.required, Validators.email]]
  })

  constructor(private router: Router, private fb: UntypedFormBuilder) { }

  ngOnInit() {
  }

  onSubmit(event: Event) {
    event.preventDefault();

    if (this.form.invalid) {
      return;
    }

    this.router.navigate(['/register'], {
      queryParams: {
        email: this.email.value
      }
    })
  }

  get email() {
    return this.form.get('email');
  }
}
